import { cx } from "./lib/cx.ts";

export interface Crumb {
  label: string;
  href?: string;
  /** The slug or full name, shown on hover when the label is a display name. */
  title?: string;
}

/**
 * The way back up. Rule: "/" separators, linked crumbs muted, the last crumb
 * is the current page (`aria-current="page"`), bold-ish, and the only one that
 * truncates with an ellipsis. Pass `title` only when it differs from the label.
 */
export function Breadcrumb({ crumbs, class: className }: { crumbs: ReadonlyArray<Crumb>; class?: string }) {
  return (
    <nav aria-label="Breadcrumb" class={cx("ui-crumbs", className)}>
      {crumbs.map((crumb, i) => {
        const leaf = i === crumbs.length - 1;
        return (
          <span key={`${i}-${crumb.label}`} class="ui-crumbs__item" style={leaf ? { minWidth: 0 } : undefined}>
            {i > 0 && (
              <span class="ui-crumbs__sep" aria-hidden="true">
                /
              </span>
            )}
            {leaf ? (
              <span class="ui-crumbs__leaf" aria-current="page" title={crumb.title}>
                {crumb.label}
              </span>
            ) : crumb.href ? (
              <a href={crumb.href} title={crumb.title}>
                {crumb.label}
              </a>
            ) : (
              <span class="ui-crumbs__text" title={crumb.title}>
                {crumb.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
